import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './3SCLandingPageC.module.css';
import { faqData } from '../constants';

// Icon components
const StarIcon = ({ filled = true }) => (
  <svg 
    className={`${styles.starIcon} ${filled ? styles.filled : ''}`}
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 24 24" 
    fill={filled ? "currentColor" : "none"}
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26"></polygon>
  </svg>
);

const CheckIcon = () => (
  <svg 
    className={styles.benefitIcon}
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M20 6L9 17l-5-5"></path>
  </svg>
);

const DownloadIcon = () => (
  <svg 
    className={styles.downloadIcon}
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3"/>
  </svg>
);

const ExternalLinkIcon = () => (
  <svg 
    className={styles.externalIcon}
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6M15 3h6v6M10 14L21 3"/>
  </svg>
);

const ChevronDownIcon = ({ expanded }) => (
  <svg 
    className={`${styles.faqIcon} ${expanded ? styles.expanded : ''}`}
    xmlns="http://www.w3.org/2000/svg" 
    width="20" 
    height="20" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <polyline points="6,9 12,15 18,9"></polyline>
  </svg>
);

const CopyIcon = () => (
  <svg 
    className={styles.copyIcon}
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
    <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"></path>
  </svg>
);

const SCCertifiedLandingPage = () => {
  const navigate = useNavigate();
  const [activeUsageTab, setActiveUsageTab] = useState('linkedin');
  const [expandedFAQ, setExpandedFAQ] = useState(null);
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  const [deliveryAddress, setDeliveryAddress] = useState('');
  const [updatePractices, setUpdatePractices] = useState('');
  const [badgeDetails, setBadgeDetails] = useState(null);

  useEffect(() => {
    const fetchBadgeDetails = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        console.error('User is not logged in.');
        return;
      }

      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/threesc/badges/`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (response.ok) {
          const data = await response.json();
          // Update badgeDetails with the correct file URLs
          setBadgeDetails({
            ...data,
            badge_file: data.badge_file_url,
            certificate_file: data.certificate_file_url,
            brand_name: data.brand_name, // Include brand_name in badgeDetails
          });
        } else {
          console.error('Failed to fetch badge details:', await response.json());
        }
      } catch (error) {
        console.error('Error fetching badge details:', error);
      }
    };

    fetchBadgeDetails();
  }, []);

  const toggleFAQ = (index) => {
    setExpandedFAQ(expandedFAQ === index ? null : index);
  };

  const handleRegenerateScore = () => {
    setShowUpdateForm(true);
  };

  const handleLinkedInOpen = () => {
    window.open('https://linkedin.com', '_blank');
  };

  const handleCopyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    // You could add a toast notification here
  };

  // const handleDownload = async (badgeDetails, type) => {
  //   if (!badgeDetails) return;
  //   const url = type === 'certificate' ? badgeDetails.certificate_file : badgeDetails.badge_file;
  //   if (!url) return;

  //   const fallbackOpen = () => {
  //     // If blob download fails (e.g., CORS), open the URL in a new tab as a fallback
  //     window.open(url, '_blank', 'noopener');
  //   };

  //   try {
  //     const response = await fetch(url, { mode: 'cors', credentials: 'omit' });
  //     // if (!response.ok) {
  //     //   fallbackOpen();
  //     //   return;
  //     // }
  //     const blob = await response.blob();
  //     const objectUrl = window.URL.createObjectURL(blob);
  //     const link = document.createElement('a');
  //     link.href = objectUrl;

  //     // Determine filename
  //     const contentType = response.headers.get('content-type') || '';
  //     const isPdf = contentType.includes('pdf') || url.toLowerCase().endsWith('.pdf');
  //     const isPng = contentType.includes('png') || url.toLowerCase().endsWith('.png');
  //     const isJpg = contentType.includes('jpeg') || contentType.includes('jpg') || url.toLowerCase().match(/\.jpe?g$/);

  //     let extension = 'bin';
  //     if (isPdf) extension = 'pdf';
  //     else if (isPng) extension = 'png';
  //     else if (isJpg) extension = 'jpg';

  //     const filename = type === 'certificate'
  //       ? `3SC_Certificate_${badgeDetails.unique_code}.${extension}`
  //       : `3SC_Badge_${badgeDetails.unique_code}.${extension}`;

  //     link.setAttribute('download', filename);
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //     window.URL.revokeObjectURL(objectUrl);
  //   } catch (err) {
  //     console.error('Download failed, falling back to opening URL:', err);
  //     fallbackOpen();
  //   }
  // };

  const handleDownload = async (badgeDetails, type) => {
    const token = localStorage.getItem('token');
    if (!token) {
      console.error('User is not logged in.');
      return;
    }

    if (!badgeDetails) return;

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/threesc/download/${type}/`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Download failed: ${response.status}`);
      }

      const blob = await response.blob();

      const extension = type === 'certificate'
        ? badgeDetails.certificate_file.split('.').pop()
        : badgeDetails.badge_file.split('.').pop();

      const filename = type === 'certificate'
        ? `3SC_Certificate_${badgeDetails.unique_code}.${extension}`
        : `3SC_Badge_${badgeDetails.unique_code}.${extension}`;

      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error('Download failed', err);
      window.open(
        type === 'certificate' ? badgeDetails.certificate_file : badgeDetails.badge_file,
        '_blank',
        'noopener'
      );
    }
  };

  const renderStars = (score) => {
    return Array.from({ length: 5 }, (_, index) => (
      <StarIcon key={index} filled={index < score} />
    ));
  };

  const renderUsageContent = () => {
    switch (activeUsageTab) {
      case 'linkedin':
        return (
          <div className={styles.usageContent}>
            <h4>Add to LinkedIn Profile</h4>
            <div className={styles.instructionSteps}>
              <div className={styles.step}>
                <span className={styles.stepNumber}>1</span>
                <span>Go to your LinkedIn Profile → Licenses & certifications</span>
              </div>
              <div className={styles.step}>
                <span className={styles.stepNumber}>2</span>
                <span>Add "Suspire 3S Certificate" as certification name</span>
              </div>
              <div className={styles.step}>
                <span className={styles.stepNumber}>3</span>
                <span>Use credential ID: <code>{badgeDetails?.unique_code}</code></span>
              </div>
              <div className={styles.step}>
                <span className={styles.stepNumber}>4</span>
                <span>Add credential URL: <code>{badgeDetails?.certificate_url}</code></span>
              </div>
            </div>
            <button className={styles.openLinkedInBtn} onClick={handleLinkedInOpen}>
              <ExternalLinkIcon />
              Open LinkedIn
            </button>
          </div>
        );
      
      case 'website':
        return (
          <div className={styles.usageContent}>
            <h4>Embed Badge on Website</h4>
            <p className={styles.embedTip}>
              💡 <strong>Tip:</strong> Place this badge on your homepage, about page, or product pages for maximum visibility
            </p>
            <div className={styles.codeBlock}>
              <pre>{`<div class="suspire-badge" data-certificate="${badgeDetails?.unique_code}">
  <img src="https://suspire.com/badge/${badgeDetails?.unique_code}" alt="Suspire 3SC Certificate" />
</div>`}</pre>
              <button 
                className={styles.copyBtn} 
                onClick={() => handleCopyToClipboard(`
<div class="suspire-badge" data-certificate="${badgeDetails?.unique_code}">
  <img src="https://suspire.com/badge/${badgeDetails?.unique_code}" alt="Suspire 3SC Certificate" />
</div>`)}
              >
                <CopyIcon />
                Copy Code
              </button>
            </div>
            <div className={styles.badgePreview}>
              <div className={styles.previewLabel}>Preview:</div>
              <div className={styles.badgeDisplay}>
                <div className={styles.certBadge}>
                  <div className={styles.badgeStars}>
                    {renderStars(badgeDetails?.badge_type === 'Gold' ? 4 : 3)}
                  </div>
                  <div className={styles.badgeText}>3SC Certified</div>
                  <div className={styles.badgeCode}>{badgeDetails?.unique_code}</div>
                </div>
              </div>
            </div>
          </div>
        );
      
      case 'packaging':
        return (
          <div className={styles.usageContent}>
            <h4>Print & Packaging Assets</h4>
            <div className={styles.downloadGrid}>
              {badgeDetails?.badge_file && (
                <div className={styles.downloadItem}>
                  <div className={styles.downloadPreview}>
                    <div className={styles.badgePreviewSmall}>Badge</div>
                  </div>
                  <h5>Badge File</h5>
                  <p>Download your badge file</p>
                  <a href={badgeDetails.badge_file} download className={styles.downloadBtn}>
                    <DownloadIcon />
                    Download Badge
                  </a>
                </div>
              )}
              {badgeDetails?.certificate_file && (
                <div className={styles.downloadItem}>
                  <div className={styles.downloadPreview}>
                    <div className={styles.certificatePreview}>CERTIFICATE</div>
                  </div>
                  <h5>Full Certificate</h5>
                  <p>Download your certificate</p>
                  <a href={badgeDetails.certificate_file} download className={styles.downloadBtn}>
                    <DownloadIcon />
                    Download Certificate
                  </a>
                </div>
              )}
            </div>
          </div>
        );
      
      case 'campaigns':
        return (
          <div className={styles.usageContent}>
            <h4>Marketing Campaign Assets</h4>
            <div className={styles.campaignSection}>
              <h5>Sample Banners</h5>
              <div className={styles.bannerGrid}>
                <div className={styles.bannerItem}>
                  <div className={styles.bannerPreview}>
                    <span>Web Banner</span>
                    <span>728x90</span>
                  </div>
                  <button className={styles.downloadBtn}>
                    <DownloadIcon />
                    Download
                  </button>
                </div>
                <div className={styles.bannerItem}>
                  <div className={styles.bannerPreview}>
                    <span>Social Media</span>
                    <span>1080x1080</span>
                  </div>
                  <button className={styles.downloadBtn}>
                    <DownloadIcon />
                    Download
                  </button>
                </div>
              </div>
            </div>
            <div className={styles.campaignSection}>
              <h5>Suggested Hashtags</h5>
              <div className={styles.hashtagList}>
                <span className={styles.hashtag}>#SuspireCertified</span>
                <span className={styles.hashtag}>#3SCCertificate</span>
                <span className={styles.hashtag}>#SustainableBrand</span>
                <span className={styles.hashtag}>#EcoVerified</span>
                <span className={styles.hashtag}>#GreenBusiness</span>
              </div>
            </div>
            <div className={styles.campaignSection}>
              <h5>Sample Copy</h5>
              <div className={styles.sampleCopy}>
                "Proud to be Suspire 3SC certified! Our {badgeDetails?.score}-star sustainability score reflects our commitment to genuine environmental responsibility. #SuspireCertified #SustainableBrand"
              </div>
              <button 
                className={styles.copyTextBtn}
                onClick={() => handleCopyToClipboard(`Proud to be Suspire 3SC certified! Our ${badgeDetails?.score}-star sustainability score reflects our commitment to genuine environmental responsibility. #SuspireCertified #SustainableBrand`)}
              >
                <CopyIcon />
                Copy Text
              </button>
            </div>
          </div>
        );
      
      default:
        return null;
    }
  };

  return (
    <div className={styles.landingPage}>
      {/* Certificate Section (Top Block) */}
      <div className={styles.certificateSection}>
        <div className={styles.certificateCard}>
          <div className={styles.certificateHeader}>
            <div className={styles.badgeContainer}>
              <div className={styles.certificateBadge}>
                {/* badge_file is a s3 url. badge should be circular and in square frame but PNG background removed (beside name) */}
                <img src={badgeDetails?.badge_file} alt="3SC Certificate" className={styles.badgeImage} />

              </div>
            </div>
            <div className={styles.certificateDetails}>
              <h1 className={styles.congratsText}>Congratulations!</h1>
              <h2 className={styles.brandName}>{badgeDetails?.brand_name || 'Your Brand'}</h2>
              <div className={styles.certificateInfo}>
                <div className={styles.infoItem}>
                  <span className={styles.label}>Certificate ID:</span>
                  <span className={styles.value}>{badgeDetails?.unique_code || 'Loading...'}</span>
                </div>
                <div className={styles.infoItem}>
                  <span className={styles.label}>Issued:</span>
                  <span className={styles.value}>{badgeDetails?.issued_at?.split('T')[0] || 'Loading...'}</span>
                </div>
                <div className={styles.infoItem}>
                  <span className={styles.label}>Valid Until:</span>
                  <span className={styles.value}>{badgeDetails?.expiry_date?.split('T')[0] || 'Loading...'}</span>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.actionButtons}>
            <button 
              className={styles.regenerateButton} 
              onClick={handleRegenerateScore}
            >
              Update / Regenerate Score
            </button>
          </div>

          {showUpdateForm && (
            <div className={styles.updateForm}>
              <h3>Request Score Update</h3>
              <div className={styles.formGroup}>
                <label>Physical Certificate Delivery Address:</label>
                <textarea
                  value={deliveryAddress}
                  onChange={(e) => setDeliveryAddress(e.target.value)}
                  placeholder="Enter your complete address for physical certificate delivery..."
                  className={styles.addressInput}
                />
              </div>
              <div className={styles.formGroup}>
                <label>Notify us of updated sustainability practices:</label>
                <textarea
                  value={updatePractices}
                  onChange={(e) => setUpdatePractices(e.target.value)}
                  placeholder="Describe any new sustainability initiatives, certifications, or practices you've implemented..."
                  className={styles.practicesInput}
                />
              </div>
              <div className={styles.formActions}>
                <button className={styles.submitBtn}>Submit Update Request</button>
                <button 
                  className={styles.cancelBtn}
                  onClick={() => setShowUpdateForm(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Certificate Mockup Section */}
      <div className={styles.certificateMockupSection}>
        <h2 className={styles.sectionTitle}>Certificate</h2>
        <img src={badgeDetails?.certificate_file} alt="3SC Certificate" className={styles.certificateImagePreview} style={{textAlign: 'center'}} />
      </div>

      {/* 2 Download Buttons for Certificate and Badge download */}
      <div className={styles.downloadButtons}>
        <button className={styles.downloadBtn} onClick={() => handleDownload(badgeDetails, 'certificate')}>
          <DownloadIcon />
          Download Certificate
        </button>
        <button className={styles.downloadBtn} onClick={() => handleDownload(badgeDetails, 'badge')}>
          <DownloadIcon />
          Download Badge
        </button>
      </div>

      {/* Usage Suggestions Section */}
      <div className={styles.usageSection}>
        <h2 className={styles.sectionTitle}>How to Use Your Certificate</h2>
        <div className={styles.usageTabs}>
          <button 
            className={`${styles.usageTab} ${activeUsageTab === 'linkedin' ? styles.active : ''}`}
            onClick={() => setActiveUsageTab('linkedin')}
          >
            LinkedIn
          </button>
          <button 
            className={`${styles.usageTab} ${activeUsageTab === 'website' ? styles.active : ''}`}
            onClick={() => setActiveUsageTab('website')}
          >
            Website
          </button>
          <button 
            className={`${styles.usageTab} ${activeUsageTab === 'packaging' ? styles.active : ''}`}
            onClick={() => setActiveUsageTab('packaging')}
          >
            Packaging
          </button>
          <button 
            className={`${styles.usageTab} ${activeUsageTab === 'campaigns' ? styles.active : ''}`}
            onClick={() => setActiveUsageTab('campaigns')}
          >
            Campaigns
          </button>
        </div>
        <div className={styles.usageTabContent}>
          {renderUsageContent()}
        </div>
      </div>

      {/* FAQ Section */}
      <div className={styles.faqSection}>
        <h2 className={styles.sectionTitle}>Frequently Asked Questions</h2>
        <div className={styles.faqList}>
          {faqData.map((faq, index) => (
            <div key={index} className={styles.faqItem}>
              <button 
                className={styles.faqQuestion}
                onClick={() => toggleFAQ(index)}
              >
                {faq.question}
                <ChevronDownIcon expanded={expandedFAQ === index} />
              </button>
              {expandedFAQ === index && (
                <div className={styles.faqAnswer}>
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SCCertifiedLandingPage;